module.exports = __webpack_public_path__ + "static/img/bgLogin.979710b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Login/bgLogin.jpeg
// module id = ZS+F
// module chunks = 37